export function getCookies () {
  if (typeof (document) === 'undefined') {
    return {};
  }

  let cookiePairs = document.cookie.split(/; ?/);
  let cookies = {};

  for (let i = 0; i < cookiePairs.length; i++) {
    let kv = cookiePairs[i].split('=', 2);
    cookies[kv[0]] = kv[1];
  }

  return cookies;
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/Cookies.js